
import axiosInstance from './authService.js';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_BASE_URL = `${BASE_URL}/api/design/designs`


   const designService = {
    //  Create a new design
    async createDesign(designData) {
     try {
      const response = await axiosInstance.post(`${API_BASE_URL}/`, designData);
      return response.data;  //  Return the created design data (including the new ID)
     } catch (error) {
      console.error('Error creating design:', error);
      throw error;  //  Re-throw the error to be handled by the component
     }
    },
	
	// Add a component to an existing design
   async addComponentToDesign(designId, componentType, x_coordinate, y_coordinate, label, jsonProperties) {
        try {
			
            // Ensure jsonProperties is an object. If undefined, null, or not an object, default to {}
            const safeJsonProperties = (typeof jsonProperties === 'object' && jsonProperties !== null)
                ? jsonProperties
                : {};
			
            // initialProperties should contain x_coordinate, y_coordinate, label, and any specific properties
            const payload = {
                type: componentType,
				x_coordinate: x_coordinate,
                y_coordinate: y_coordinate,
				label: label,
                properties: safeJsonProperties,
            };
			
			// Filter out undefined/null label if it's optional and not provided
            if (label === undefined || label === null) {
                delete payload.label;
            }
			
			console.log('Sending Add Component Payload:', payload); // Debugging: Check the final payload
			
            const response = await axiosInstance.post(`${API_BASE_URL}/${designId}/components/`, payload);
            return response.data;
        } catch (error) {
            console.error('Error adding component to design:', error.response?.data || error.message);
            throw error;
        }
    },
 
	// Fetch a list of designs
    async fetchDesigns()  {
     try {
        const response = await axiosInstance.get(`${API_BASE_URL}/`);
        return response.data;
     } catch (error) {
		 console.error('Error fetching designs:', error.response?.data || error.message);
		 throw error;
	 }
	},
 
    // Fetch a single design by ID
    async fetchDesign(designId)  {
     try {
        const response = await axiosInstance.get(`${API_BASE_URL}/${designId}/`);
        return response.data;
     } catch (error) {
		 console.error(`Error fetching design ${designId}:`, error.response?.data || error.message);
         throw error;
	 }
	},
 

    //  Update an existing design
    async updateDesign(designId, designData) {
     try {
      const response = await axiosInstance.put(`${API_BASE_URL}/${designId}/`, designData);
      return response.data;  //  Return the updated design data
     } catch (error) {
      console.error('Error updating design:', error);
      throw error;
     }
    },
	
	// Update a component in an existing design
   async updateComponentInDesign(designId, componentId, updatedData) {
        try {
            // updatedData can include x_coordinate, y_coordinate, label, and properties
            const response = await axiosInstance.put(`${API_BASE_URL}/${designId}/components/${componentId}/`, updatedData);
            return response.data;
        } catch (error) {
            console.error('Error updating component in design:', error.response?.data || error.message);
            throw error;
        }
    },
  
    // Remove a component from an existing design
   async deleteComponentFromDesign(designId, componentId) {
        try {
            await axiosInstance.delete(`${API_BASE_URL}/${designId}/components/${componentId}/`);
            return true;
        } catch (error) {
            console.error('Error deleting component from design:', error.response?.data || error.message);
            throw error;
        }
    },
 
    // Connect two components in a design
   async connectComponentsInDesign(designId, sourceComponentId, targetComponentId, connectionProperties = {}) {
        try {
            const payload = {
                source_component_id: sourceComponentId,
                target_component_id: targetComponentId,
                properties: connectionProperties, // This includes bandwidth, protocol, config, etc.
            };
            const response = await axiosInstance.post(`${API_BASE_URL}/${designId}/connections/`, payload);
            return response.data;
        } catch (error) {
            console.error('Error connecting components in design:', error.response?.data || error.message);
            throw error;
        }
    },
	
	async updateConnectionInDesign(designId, connectionId, updatedData) {
        try {
            const response = await axiosInstance.put(`${API_BASE_URL}/${designId}/connections/${connectionId}/`, updatedData);
            return response.data;
        } catch (error) {
            console.error('Error updating connection in design:', error.response?.data || error.message);
            throw error;
        }
    },
 
   // Remove a connection from a design
   async deleteConnectionFromDesign(designId, connectionId) {
        try {
            await axiosInstance.delete(`${API_BASE_URL}/${designId}/connections/${connectionId}/`);
            return true;
        } catch (error) {
            console.error('Error deleting connection from design:', error.response?.data || error.message);
            throw error;
        }
    },
 

    //  Delete a design
    async deleteDesign(designId) {
     try {
      await axiosInstance.delete(`${API_BASE_URL}/${designId}/`);
     } catch (error) {
      console.error('Error deleting design:', error);
      throw error;
     }
    },
   
   // --- AI Integration Operations ---

    async fetchDesignForAI(designId) {
        try {
            const response = await axiosInstance.get(`${API_BASE_URL}/${designId}/ai/`);
            return response.data;
        } catch (error) {
            console.error('Error fetching design for AI:', error.response?.data || error.message);
            throw error;
        }
    },

    async applyAISuggestionsToDesign(designId, aiSuggestedData) {
        try {
            const response = await axiosInstance.post(`${API_BASE_URL}/${designId}/ai/`, aiSuggestedData);
            return response.data;
        } catch (error) {
            console.error('Error applying AI suggestions to design:', error.response?.data || error.message);
            throw error;
        }
    },
   }

   export default designService;